module.exports = __webpack_public_path__ + "images/certify-emburse-logo.d58adc783cc37079178b2c42aab511e9.svg";